import React from 'react';

// import PropTypes from 'prop-types';
import DietSettingsConnectorApollo from '@dietlabs/components/src/ApolloConnectors/DietSettings/Fetch/DietSettingsConnectorApollo';
import DietSettingsValidateDataConnectorApollo from '@dietlabs/components/src/ApolloConnectors/DietSettings/Validate/DietSettingsValidateDataConnectorApollo';
import DietSettingsGenerateDietConnectorApollo from '@dietlabs/components/src/ApolloConnectors/DietSettings/GenerateDiet/DietSettingsGenerateDietConnectorApollo';
import DietSettingsIndexContainer from './DietSettingsIndexContainer';

class DietSettingsIndexPage extends React.Component {
    static propTypes = {};

    render() {
        return (
            <DietSettingsConnectorApollo>
                {({ ...dietSettingsData }) => (
                    <DietSettingsValidateDataConnectorApollo>
                        {({ validateData }) => (
                            <DietSettingsGenerateDietConnectorApollo>
                                {({ generateDiet }) => (
                                    <DietSettingsIndexContainer
                                        {...dietSettingsData}
                                        {...{ validateData }}
                                        {...{ generateDiet }}
                                    />
                                )}
                            </DietSettingsGenerateDietConnectorApollo>
                        )}
                    </DietSettingsValidateDataConnectorApollo>
                )}
            </DietSettingsConnectorApollo>
        );
    }
}

export default DietSettingsIndexPage;
